import { render, staticRenderFns } from "./EmailSendingOptions.vue?vue&type=template&id=1610d582&lang=pug"
import script from "./EmailSendingOptions.vue?vue&type=script&lang=js"
export * from "./EmailSendingOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports